export class SchedulerPageRequest {

    searchValue: string;
    pageNum: number;
    pageSize: number;
    sortBy: string;
    sortDir: string;
}
